const FAQ_ITEMS = [
  {
    q: '天美影视是否需要注册才能观看？',
    a: '不需要。天美影视所有内容均为免费在线观看，无需注册、无需登录，打开网站即可畅享高清影视资源，真正做到即点即看，方便快捷。',
  },
  {
    q: '天美影视的画质怎么样？支持哪些清晰度？',
    a: '天美影视提供高清、超清等多种画质选择，采用先进的视频编码技术，确保画面清晰细腻。根据您的网络状况自动适配最佳清晰度，同时支持手动切换。',
  },
  {
    q: '观看时会卡顿或缓冲吗？',
    a: '天美影视采用智能CDN加速和多节点分发技术，在全国范围内部署了高速服务器，确保观影过程流畅不卡顿。即使用户在高峰期观影，也能享受稳定流畅的播放体验。',
  },
  {
    q: '天美影视支持哪些设备观看？',
    a: '天美影视全面支持桌面电脑、平板、手机等多种设备。无论您使用Windows、Mac、iOS还是Android系统，都能获得一致的高清流畅观影体验，适配各类屏幕尺寸。',
  },
  {
    q: '天美影视的片源更新速度如何？',
    a: '天美影视拥有专业的内容运营团队，院线新片下映后快速上线，热播剧集实现同步更新，综艺和动漫每周定时追更。每日都有新内容上线，确保您不错过任何精彩。',
  },
  {
    q: '天美影视是否安全？会有广告弹窗吗？',
    a: '天美影视高度重视用户体验和安全保障，网站采用HTTPS加密传输，不含恶意弹窗和强制广告。我们致力于打造纯净、安全的观影环境，让您放心追剧。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于天美影视的常见疑问解答</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[960px] mx-auto">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                  <span className="text-primary-600 text-sm font-bold">Q</span>
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.q}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}